import React, {
    PropsWithChildren, useMemo
} from 'react';
import { Provider } from 'react-redux';
import {
    RouteComponentProps, withRouter
} from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

import { AppContext } from '../app.types';
import { configureStore } from './configure-store';

type ReduxProviderProps = RouteComponentProps & PropsWithChildren<RequiredProps>;

// omissions are needed as history is injected from withRouter hoc
type RequiredProps = Omit<AppContext, 'history'>;

export const ReduxContextProvider = ({
    children, history
}: ReduxProviderProps) => {
    // // useMemo to prevent the parent new renders creating a new one
    // // invalidating the store each route change
    const {
        store, persistor
    } = useMemo(() => {
        const singleStore = configureStore({ history });

        // @ts-ignore add store it to window for debugging eg ___store.getState()
        window.___store = singleStore;

        return singleStore;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Provider store={store}>
            <PersistGate persistor={persistor}>
                {children}
            </PersistGate>
        </Provider>
    );
};

export const ReduxProvider = withRouter(ReduxContextProvider);
